import React, { useEffect, useState } from "react";
import LoadingPage from "../components/LoadingPage";
import ErrorPage from "../components/ErrorPage";
import {
  drawDetailsProps,
  DemogetDrawDetail,
} from "../components/apis/getDrawDetail";
import { ticketsProps } from "../components/apis/getTickets";
import DemoPurchaseTicketPage from "./DemoPurchaseTicketPage";
import DemoGamePage from "./DemoGamePage";
import BingoPixiApp from "../components/pixi-app";
import { UserProps } from "../components/apis/user";
import CancelPop from "../components/popups/CancelPop";
import { handleNavigationTobackOffice } from "../components/utils/NavigateToBackOffice";
import { WinningResult } from "./DemoBingoTickets";
import DemoWinnersPopup from "./DemoWinnersPopup";
import { drawId } from "../components/urlParams";
import ErrorBoundary from "../components/ErrorBoundary";

export type pageRoutes =
  | "loadingPage"
  | "purchaseTicketPage"
  | "gamePage"
  | "errorPage";

export interface closeModalData {
  status: boolean;
  test?: string;
  btnText?: string;
}
const DemoPlayApp: React.FC = () => {
  const [currentPage, setCurrentPage] = useState<pageRoutes>("loadingPage");
  const [drawDetails, setDrawDetails] = useState<drawDetailsProps>();
  const [ticketData, setTicketData] = useState<ticketsProps>();
  const [showWinners, setShowWinners] = useState<boolean>(false);
  const [closeModal, setCloseModal] = useState<closeModalData>({
    status: false,
    test: undefined,
  });
  const [cutoffTime, setCutoffTime] = useState(
    new Date(new Date().getTime() + 30 * 1000)
  );
  const [selectTickets, setSelectTickets] = useState<number>(1);
  const [userWallet, setUserWallet] = useState<UserProps>();
  const [play, setPlay] = useState<boolean>(false);
  const [winningTickets, setWinningTickets] = useState<{
    [ticketId: string]: WinningResult[];
  }>({});
  const [amount, setAmount] = useState(5000);
  const [ShowModal, setShowModal] = useState<closeModalData>({
    status: false,
    test: undefined,
    btnText: undefined,
  });
  const [reducedCount, setReducedCount] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      const now: Date = new Date();
      const timeLeft: number = Math.round(
        (cutoffTime.getTime() - now.getTime()) / 1000
      );
      if (timeLeft <= 0) {
        setCutoffTime(new Date(new Date().getTime() + 30 * 1000));
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [cutoffTime]);

  const handleCloseModal = (data: closeModalData) => {
    setCloseModal({ status: data.status, test: data.test });
  };

  const handleShowModal = (data: closeModalData) => {
    setShowModal({
      status: data.status,
      test: data.test,
      btnText: data.btnText,
    });
  };

  const handleTicketPurchase = () => {
    setCurrentPage("gamePage");
  };

  const handleTicketCount = (num: number) => {
    setSelectTickets(num);
  };

  const handlePlayButton = (status: boolean) => {
    setPlay(status);
  };
  const handleTicketData = (data: ticketsProps) => {
    setTicketData(data);
  };
  const handleShowWinnersModal = (status: boolean) => {
    setShowWinners(status);
  };

  const handleWinnersData = (data: any) => {
    setWinningTickets(data);
  };
  const key = `userDemoAmount_${drawId}`;
  const handleAmount = (amount: number) => {
    setAmount(amount);
    window.localStorage.setItem(key, JSON.stringify(amount));
  };

  const handleReducedCount = (count: number) => {
    setReducedCount(reducedCount + count);
  };
  useEffect(() => {
    if (key) {
      try {
        const getAmount = window.localStorage.getItem(key);
        if (getAmount) {
          const parsedAmount = JSON.parse(getAmount);
          if (typeof parsedAmount === "number") {
            setAmount(parsedAmount);
          } else {
            console.warn("Stored amount is not a number:", parsedAmount);
          }
        } else {
          setAmount(5000);
        }
      } catch (error) {
        console.error("Error parsing localStorage amount:", error);
      }
    }
  }, [key]);
  const renderPage = () => {
    switch (currentPage) {
      case "loadingPage":
        return <LoadingPage />;
      case "purchaseTicketPage":
        return (
          <DemoPurchaseTicketPage
            drawDetails={drawDetails}
            handleShowModal={handleShowModal}
            ticketData={ticketData}
            setCurrentPage={setCurrentPage}
            onTicketPurchase={handleTicketPurchase}
            cutoffTime={cutoffTime}
            selectTickets={selectTickets}
            handleTicketCount={handleTicketCount}
            handlePlayButton={handlePlayButton}
            amount={amount}
            handleAmount={handleAmount}
          />
        );
      case "gamePage":
        return (
          <DemoGamePage
            handleReducedCount={handleReducedCount}
            amount={amount}
            showWinners={showWinners}
            closeModal={closeModal}
            winningTickets={winningTickets}
            handleWinnersData={handleWinnersData}
            handleShowWinnersModal={handleShowWinnersModal}
            handleCloseModal={handleCloseModal}
            handleAmount={handleAmount}
            handleTicketData={handleTicketData}
            selectTickets={selectTickets}
            ticketData={ticketData}
            drawDetails={drawDetails}
            userWallet={userWallet}
          />
        );
      case "errorPage":
        return <ErrorPage />;
      default:
        return <LoadingPage />;
    }
  };

  useEffect(() => {
    const drawDetails = async () => {
      try {
        const data = await DemogetDrawDetail();
        setDrawDetails(data);
      } catch (error) { }
    };
    drawDetails();
  }, []);
  useEffect(() => {
    if (play) {
      setTicketData({ count: selectTickets, rows: [] });
      setCurrentPage("gamePage");
    }
  }, [play, selectTickets]);

  useEffect(() => {
    if (currentPage === "loadingPage") {
      const timer = setTimeout(() => {
        if (ticketData && ticketData.count > 0) {
          setCurrentPage("gamePage");
        } else {
          setCurrentPage("purchaseTicketPage");
        }
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [currentPage, ticketData]);

  const showModals = () => {
    setShowModal({ status: false, test: "" });
    setAmount(5000);
  };
  return (
    <ErrorBoundary>
      <div className="app  relative w-full h-screen">
        <div className={`w-full fixed top-0 left-0 h-full ${currentPage === "gamePage" ? "block" : "hidden"}`}>
          <BingoPixiApp />
        </div>

        <div
          className={`w-full relative  `}
        >
          {renderPage()}
        </div>

        <div>
          {showWinners && (
            <DemoWinnersPopup
              reducedCount={reducedCount}
              drawDetails={drawDetails}
              winners={winningTickets}
              showWinners={showWinners}
              onClose={() => handleNavigationTobackOffice()}
            />
          )}
          {closeModal.status && !showWinners && (
            <CancelPop
              closeModal={closeModal}
              onClose={() => handleNavigationTobackOffice()}
            />
          )}
          {ShowModal.status && (
            <CancelPop closeModal={ShowModal} onClose={() => showModals()} />
          )}
        </div>
      </div>
    </ErrorBoundary>
  );
};

export default DemoPlayApp;
